/**
 * VenueFlow Commercial — Club Bases Configuration
 * 
 * Maps each club to their Airtable base credentials and table IDs.
 * Used for syncing approved playlists to club CG and Ribbon operator views.
 * 
 * SETUP:
 * 1. Add PAT tokens to .env.local (never commit these!)
 * 2. Get table IDs from each club base
 * 3. Update this file with correct IDs
 */

// ============================================================
// AFL CLUBS
// ============================================================
export const AFL_CLUBS = {
  ADE: {
    name: "Adelaide",
    code: "ADE",
    baseId: process.env.REACT_APP_ADELAIDE_BASE_ID || "",
    pat: process.env.REACT_APP_ADELAIDE_PAT || "",
    fixturesTableId: "", // TODO: Add table ID
    cgOperatorTableId: "", // TODO: Add table ID
    ribbonOperatorTableId: "", // TODO: Add table ID
    matchIdField: "Match ID", // Field name in club's Fixtures table
  },
  BRI: {
    name: "Brisbane",
    code: "BRI",
    baseId: process.env.REACT_APP_BRISBANE_BASE_ID || "",
    pat: process.env.REACT_APP_BRISBANE_PAT || "",
    fixturesTableId: "",
    cgOperatorTableId: "",
    ribbonOperatorTableId: "",
    matchIdField: "Match ID",
  },
  CAR: {
    name: "Carlton",
    code: "CAR",
    baseId: process.env.REACT_APP_CARLTON_BASE_ID || "",
    pat: process.env.REACT_APP_CARLTON_PAT || "",
    fixturesTableId: "",
    cgOperatorTableId: "",
    ribbonOperatorTableId: "",
    matchIdField: "Match ID",
  },
  COL: {
    name: "Collingwood",
    code: "COL",
    baseId: process.env.REACT_APP_COLLINGWOOD_BASE_ID || "",
    pat: process.env.REACT_APP_COLLINGWOOD_PAT || "",
    fixturesTableId: "",
    cgOperatorTableId: "",
    ribbonOperatorTableId: "",
    matchIdField: "Match ID",
  },
  ESS: {
    name: "Essendon",
    code: "ESS",
    baseId: process.env.REACT_APP_ESSENDON_BASE_ID || "",
    pat: process.env.REACT_APP_ESSENDON_PAT || "",
    fixturesTableId: "",
    cgOperatorTableId: "",
    ribbonOperatorTableId: "",
    matchIdField: "Match ID",
  },
  FRE: {
    name: "Fremantle",
    code: "FRE",
    baseId: process.env.REACT_APP_FREMANTLE_BASE_ID || "",
    pat: process.env.REACT_APP_FREMANTLE_PAT || "",
    fixturesTableId: "",
    cgOperatorTableId: "",
    ribbonOperatorTableId: "",
    matchIdField: "Match ID",
  },
  GCS: {
    name: "Gold Coast",
    code: "GCS",
    baseId: process.env.REACT_APP_GOLDCOAST_BASE_ID || "",
    pat: process.env.REACT_APP_GOLDCOAST_PAT || "",
    fixturesTableId: "",
    cgOperatorTableId: "",
    ribbonOperatorTableId: "",
    matchIdField: "Match ID",
  },
  GEE: {
    name: "Geelong",
    code: "GEE",
    baseId: process.env.REACT_APP_GEELONG_BASE_ID || "",
    pat: process.env.REACT_APP_GEELONG_PAT || "",
    fixturesTableId: "",
    cgOperatorTableId: "",
    ribbonOperatorTableId: "",
    matchIdField: "Match ID",
  },
  GWS: {
    name: "GWS Giants",
    code: "GWS",
    baseId: process.env.REACT_APP_GWS_BASE_ID || "",
    pat: process.env.REACT_APP_GWS_PAT || "",
    fixturesTableId: "",
    cgOperatorTableId: "",
    ribbonOperatorTableId: "",
    matchIdField: "Match ID",
  },
  HAW: {
    name: "Hawthorn",
    code: "HAW",
    baseId: process.env.REACT_APP_HAWTHORN_BASE_ID || "",
    pat: process.env.REACT_APP_HAWTHORN_PAT || "",
    fixturesTableId: "",
    cgOperatorTableId: "",
    ribbonOperatorTableId: "",
    matchIdField: "Match ID",
  },
  MEL: {
    name: "Melbourne",
    code: "MEL",
    baseId: process.env.REACT_APP_MELBOURNE_BASE_ID || "",
    pat: process.env.REACT_APP_MELBOURNE_PAT || "",
    fixturesTableId: "",
    cgOperatorTableId: "",
    ribbonOperatorTableId: "",
    matchIdField: "Match ID",
  },
  NOR: {
    name: "North Melbourne",
    code: "NOR",
    altCodes: ["NM"],
    baseId: process.env.REACT_APP_NORTH_BASE_ID || "",
    pat: process.env.REACT_APP_NORTH_PAT || "",
    fixturesTableId: "",
    cgOperatorTableId: "",
    ribbonOperatorTableId: "",
    matchIdField: "Match ID",
  },
  POR: {
    name: "Port Adelaide",
    code: "POR",
    baseId: process.env.REACT_APP_PORT_BASE_ID || "",
    pat: process.env.REACT_APP_PORT_PAT || "",
    fixturesTableId: "",
    cgOperatorTableId: "",
    ribbonOperatorTableId: "",
    matchIdField: "Match ID",
  },
  RIC: {
    name: "Richmond",
    code: "RIC",
    baseId: process.env.REACT_APP_RICHMOND_BASE_ID || "",
    pat: process.env.REACT_APP_RICHMOND_PAT || "",
    fixturesTableId: "",
    cgOperatorTableId: "",
    ribbonOperatorTableId: "",
    matchIdField: "Match ID",
  },
  STK: {
    name: "St Kilda",
    code: "STK",
    baseId: process.env.REACT_APP_STKILDA_BASE_ID || "",
    pat: process.env.REACT_APP_STKILDA_PAT || "",
    fixturesTableId: "",
    cgOperatorTableId: "",
    ribbonOperatorTableId: "",
    matchIdField: "Match ID",
  },
  SYD: {
    name: "Sydney",
    code: "SYD",
    baseId: process.env.REACT_APP_SYDNEY_BASE_ID || "",
    pat: process.env.REACT_APP_SYDNEY_PAT || "",
    fixturesTableId: "",
    cgOperatorTableId: "",
    ribbonOperatorTableId: "",
    matchIdField: "Match ID",
  },
  WCE: {
    name: "West Coast",
    code: "WCE",
    baseId: process.env.REACT_APP_WESTCOAST_BASE_ID || "",
    pat: process.env.REACT_APP_WESTCOAST_PAT || "",
    fixturesTableId: "",
    cgOperatorTableId: "",
    ribbonOperatorTableId: "",
    matchIdField: "Match ID",
  },
  WBD: {
    name: "Western Bulldogs",
    code: "WBD",
    altCodes: ["WB"],
    baseId: process.env.REACT_APP_BULLDOGS_BASE_ID || "",
    pat: process.env.REACT_APP_BULLDOGS_PAT || "",
    fixturesTableId: "",
    cgOperatorTableId: "",
    ribbonOperatorTableId: "",
    matchIdField: "Match ID",
  },
  // Lumen8 Finals — event portal for the AFL Finals series.
  // Kept in AFL_CLUBS (rather than a new export) so every existing
  // { ...AFL_CLUBS, ...NRL_CLUBS } merge site picks it up automatically.
  FIN: {
    name: "Lumen8 Finals",
    code: "FIN",
    baseId: process.env.REACT_APP_FINALS_BASE_ID || "",
    pat: process.env.REACT_APP_FINALS_PAT || "",
    fixturesTableId: "",
    cgOperatorTableId: "",
    ribbonOperatorTableId: "",
    matchIdField: "Match ID",
  },
};

// ============================================================
// NRL CLUBS (add as needed)
// ============================================================
export const NRL_CLUBS = {
  BRO: {
    name: "Broncos",
    code: "BRO",
    baseId: process.env.REACT_APP_BRONCOS_BASE_ID || "",
    pat: process.env.REACT_APP_BRONCOS_PAT || "",
    fixturesTableId: "",
    cgOperatorTableId: "",
    ribbonOperatorTableId: "",
    matchIdField: "Match ID",
  },
  COW: {
    name: "Cowboys",
    code: "COW",
    baseId: process.env.REACT_APP_COWBOYS_BASE_ID || "",
    pat: process.env.REACT_APP_COWBOYS_PAT || "",
    fixturesTableId: "",
    cgOperatorTableId: "",
    ribbonOperatorTableId: "",
    matchIdField: "Match ID",
  },
  STO: {
    name: "Storm",
    code: "STO",
    baseId: process.env.REACT_APP_STORM_BASE_ID || "",
    pat: process.env.REACT_APP_STORM_PAT || "",
    fixturesTableId: "",
    cgOperatorTableId: "",
    ribbonOperatorTableId: "",
    matchIdField: "Match ID",
  },
  // Add more NRL clubs as needed
};

// ============================================================
// COMBINED LOOKUP
// ============================================================
export const CLUB_BASES = {
  ...AFL_CLUBS,
  ...NRL_CLUBS,
};

// ============================================================
// HELPER FUNCTIONS
// ============================================================

/**
 * Get club config from Match ID
 * Match ID format: "RIC-CAR-R1-2025" where first code is home team
 */
export function getHomeClubFromMatchId(matchId) {
  if (!matchId) return null;
  const homeCode = matchId.split('-')[0];
  return CLUB_BASES[homeCode] || null;
}

/**
 * Get club config by code
 */
export function getClubByCode(code) {
  return CLUB_BASES[code] || null;
}

/**
 * Check if club config is complete (has all required IDs)
 */
export function isClubConfigured(clubCode) {
  const club = CLUB_BASES[clubCode];
  if (!club) return false;
  
  return Boolean(
    club.baseId &&
    club.pat &&
    club.fixturesTableId &&
    club.cgOperatorTableId &&
    club.ribbonOperatorTableId
  );
}

/**
 * Get list of configured clubs
 */
export function getConfiguredClubs() {
  return Object.entries(CLUB_BASES)
    .filter(([code]) => isClubConfigured(code))
    .map(([code, config]) => ({ code, ...config }));
}

/**
 * Validate club config and return missing items
 */
export function validateClubConfig(clubCode) {
  const club = CLUB_BASES[clubCode];
  if (!club) return { valid: false, missing: ['Club not found'] };
  
  const missing = [];
  if (!club.baseId) missing.push('baseId');
  if (!club.pat) missing.push('PAT token');
  if (!club.fixturesTableId) missing.push('fixturesTableId');
  if (!club.cgOperatorTableId) missing.push('cgOperatorTableId');
  if (!club.ribbonOperatorTableId) missing.push('ribbonOperatorTableId');
  
  return {
    valid: missing.length === 0,
    missing,
  };
}

export default CLUB_BASES;
